import { createContext, useContext } from 'react';

import { Location } from 'react-router-dom';

export const GuardedLocationContext = createContext<Location | null>(null);

/**
 * Returns the location that Routes should render against.
 * When a guard is blocking, this returns the previous (safe) location
 * so the current page stays mounted while the modal is shown.
 */
export const useGuardedLocation = () => useContext(GuardedLocationContext);